import * as uuid from 'uuid';
import getReCaptcha2PublicConfig from './getReCaptcha2PublicConfig.client';

/**
 * Initializes @rcm/recaptcha-2.
 *
 * This will ensure that the ReCAPTCHA V2 script is loaded.
 *
 * This can be safely called multiple times. Any initialization steps that
 * have already been performed will be skipped. However, there is a very slight
 * performance overhead when calling, so excessively repeated calls should be
 * avoided.
 */
const initReCaptcha2 = () => {
  // Fetch ReCAPTCHA config from app state
  const { apiSrc, locale } = getReCaptcha2PublicConfig();

  // Create the global data store if it does not already exist.
  const globalData = (window._RCM_RECAPTCHA_2 = window._RCM_RECAPTCHA_2 || {});

  // Create an ID for the ReCAPTCHA script element if no ID already exists
  const scriptElementId = (globalData.scriptElementId = globalData.scriptElementId || uuid.v4());

  // Create the ReCAPTCHA script element if it does not already exist.
  let scriptElement = window.document.getElementById(scriptElementId) as HTMLScriptElement;
  if (!scriptElement) {
    scriptElement = window.document.createElement('script');
    scriptElement.setAttribute('id', scriptElementId);
    scriptElement.setAttribute('src', `${apiSrc}${locale ? `?hl=${locale}` : ''}`);
    scriptElement.setAttribute('async', 'async');
    scriptElement.setAttribute('defer', 'defer');
    window.document.body.appendChild(scriptElement);
  }
};

export default initReCaptcha2;
